module.exports = "mat-dialog-content{width:450px}.btn-cancel{margin-left:12px}"